import { PostAdd, Save } from '@mui/icons-material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Box, CircularProgress, MenuItem, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CalendarGridActionPopup = ({
  popoverElement,
  handleCloseMenu,
  handleSaveAsDraft,
  handleEditAsNewPost,
  hasEditAccess,
  hasApproveAccess,
  handleDeletePost,
  loading,
  handleUnapprovePost,
}) => {
  const { t: translate } = useTranslation();
  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { p: 1, width: 170, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
      }}
    >
      {' '}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <MenuItem sx={{ color: 'warning.main' }} onClick={handleSaveAsDraft}>
            <Save sx={{ mr: 1 }} /> {translate('scheduled_post.save_as_draft')}
          </MenuItem>
          <MenuItem sx={{ color: 'info.main' }} onClick={handleEditAsNewPost}>
            <PostAdd sx={{ mr: 1 }} />
            {translate('scheduled_post.edit_as_new_post')}
          </MenuItem>
          {hasEditAccess && (
            <MenuItem sx={{ color: 'error.main' }} onClick={handleDeletePost}>
              <DeleteForeverIcon sx={{ mr: 1 }} />
              {translate('scheduled_post.delete_post')}
            </MenuItem>
          )}
        </>
      )}
    </Popover>
  );
};
export default CalendarGridActionPopup;
